<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :span="22" :offset="1"  class="page-title">EmailTemplate Maintenance</el-col>
      <el-col :span="22" :offset="1" class="hight-btn" >
        <el-button @click="showAddDialog">Add</el-button>
        <el-button @click="showModifyDialog">Modify</el-button>
      </el-col>
      <el-col :span="22" :offset="1">
        <el-table class="stakeholder-category-table" empty-text="No Data" :data="emailTemplateList" ref="multipleTable" stripe
                  max-height="700" style="width: 100%" highlight-current-row @selection-change="handleSelectionChange" @row-dblclick="handleRowDBClick"
                  :default-sort = "{prop: 'category', order: 'ascending'}">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="Type" sortable prop="type" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.type}}</span>
            </template>
          </el-table-column>
          <el-table-column label="FromEmail" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.fromEmail}}</span>
            </template>
          </el-table-column>
          <el-table-column label="ToList" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.toList}}</span>
            </template>
          </el-table-column>
          <el-table-column label="CcList"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.ccList}}</span>
            </template>
          </el-table-column>
          <el-table-column label="BccList"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.bccList}}</span>
            </template>
          </el-table-column>
          <el-table-column label="SubjectEn"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.subjectEn}}</span>
            </template>
          </el-table-column>
          <el-table-column label="SubjectSc"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.subjectSc}}</span>
            </template>
          </el-table-column>
          <el-table-column label="SubjectTc"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.subjectTc}}</span>
            </template>
          </el-table-column>
          <el-table-column label="ContentEn"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.contentEn}}</span>
            </template>
          </el-table-column>
          <el-table-column label="ContentSc"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.contentSc}}</span>
            </template>
          </el-table-column>
          <el-table-column label="ContentTc"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.contentTc}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Description" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.description}}</span>
            </template>
          </el-table-column>
          <el-table-column label="CreatedDate" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.createdDate !== null">{{scope.row.createdDate.substring(0, scope.row.createdDate.lastIndexOf('.')).replace('T', ' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="CreatedBy" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.createdBy}}</span>
            </template>
          </el-table-column>
          <el-table-column label="ModifiedDate" :show-overflow-tooltip="true" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.modifiedDate !== null">{{scope.row.modifiedDate.substring(0, scope.row.modifiedDate.lastIndexOf('.')).replace('T', ' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="ModifiedBy" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.modifiedBy}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="updateDialogTitle" width="800px" :visible.sync="dialogVisible"  top="10px" @close='closeDialog'>
          <el-form :model="emailTemplate" label-position="top" class="dialog-form" ref="updateForm" :rules="rules">
            <el-form-item label="Type" prop="type">
              <el-input v-model="emailTemplate.type" :disabled="true" v-if="updateDialogTitle === dialogType" style="width: 100%;"/>
              <el-input v-model="emailTemplate.type" v-else style="width: 100%;"/>
            </el-form-item>
            <el-form-item label="FromEmail">
              <el-input v-model="emailTemplate.fromEmail" style="width: 100%;"/>
            </el-form-item>
            <el-form-item label="ToList">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 3}" v-model="emailTemplate.toList"/>
            </el-form-item>
            <el-form-item label="CcList">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 3}" v-model="emailTemplate.ccList"/>
            </el-form-item>
            <el-form-item label="BccList">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 3}" v-model="emailTemplate.bccList"/>
            </el-form-item>
            <el-form-item label="SubjectEn" prop="subjectEn">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4}" v-model="emailTemplate.subjectEn"/>
            </el-form-item>
            <el-form-item label="SubjectSc">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4}" v-model="emailTemplate.subjectSc"/>
            </el-form-item>
            <el-form-item label="SubjectTc">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4}" v-model="emailTemplate.subjectTc"/>
            </el-form-item>
            <el-form-item label="ContentEn" prop="contentEn">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 10}" v-model="emailTemplate.contentEn"/>
            </el-form-item>
            <el-form-item label="ContentSc">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 10}" v-model="emailTemplate.contentSc"/>
            </el-form-item>
            <el-form-item label="ContentTc">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 10}" v-model="emailTemplate.contentTc"/>
            </el-form-item>
            <el-form-item label="Description">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4}" v-model="emailTemplate.description"/>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancelBtn">Cancel</el-button>
          <el-button type="danger" @click="modifyEmailTemplateList">Save</el-button>
        </span>
        </el-dialog>
      </el-col>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue'
import Constant from '@/common/Constant'
import { findAllEmailTemplate, updateEmailTemplate } from '@/services/email.service';
import { verifyUserInfo } from '@/services/login.service'

export default {
  components: {
    Footer
  },
  data () {
    return {
      emailTemplateList: [],
      emailTemplate: {
        type: '',
        fromEmail: '',
        toList: '',
        ccList: '',
        bccList: '',
        subjectEn: '',
        subjectSc: '',
        subjectTc: '',
        contentEn: '',
        contentSc: '',
        contentTc: '',
        description: '',
        modifiedBy: ''
      },
      multipleSelection: [],
      dialogVisible: false,
      readonly: true,
      userType: '',
      userName: '',
      updateDialogTitle: '',
      dialogType: 'Modify',
      rules: {
        type: [
          {required: true, message: Constant.INPUT_EMAIL_TEMPLATE_TYPE, trigger: ['blur', 'change']}
        ],
        subjectEn: [
          {required: true, message: Constant.INPUT_SUBJECT_EN, trigger: ['blur', 'change']}
        ],
        contentEn: [
          {required: true, message: Constant.INPUT_CONTENT_EN, trigger: ['blur', 'change']}
        ]
      }
    }
  },
  methods: {
    async displayAllEmailTemplate () {
      this.$loading({fullscreen: true});
      let emailTemplateList = await findAllEmailTemplate();
      this.emailTemplateList = emailTemplateList.data;
      this.$loading({fullscreen: true}).close();
    },
    modifyEmailTemplateList () {
      this.$refs.updateForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.saveEmailTemplate();
        }
      });
    },
    async saveEmailTemplate () {
      this.$loading({fullscreen: true});
      this.emailTemplate.modifiedBy = this.userName;
      let emailTemplateList = await updateEmailTemplate(this.emailTemplate);
      if (emailTemplateList.code === Constant.RESPONSE_SUCCESS_CODE) {
        this.emailTemplateList = emailTemplateList.data;
        this.$message.success(Constant.SAVE_SUCCEED);
      }
      this.dialogVisible = false;
      this.$loading({fullscreen: true}).close();
    },
    showModifyDialog () {
      this.updateDialogTitle = 'Modify';
      if (this.multipleSelection.length === 1) {
        this.emailTemplate = JSON.parse(JSON.stringify(this.multipleSelection[0]));
        this.dialogVisible = true;
      } else {
        if (this.multipleSelection.length === 0) {
          this.$message.warning(Constant.SELECT_NONE_LINE);
        } else {
          this.$message.warning(Constant.SELECT_MULTIPLE_LINES);
        }
      }
    },
    showAddDialog () {
      this.updateDialogTitle = 'Add';
      this.dialogVisible = true;
    },
    handleCancelBtn () {
      this.$refs.updateForm.resetFields();
      this.dialogVisible = false;
    },
    closeDialog () {
      this.$refs.updateForm.resetFields();
      this.emailTemplate = {};
      this.dialogVisible = false;
    },
    handleSelectionChange (value) {
      this.multipleSelection = value;
    },
    handleRowDBClick (row, event) {
      this.updateDialogTitle = 'Modify';
      this.emailTemplate = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    async verifyUser () {
      let user = await verifyUserInfo();

      this.userType = user.role;
      this.userName = user.domain;
    }
  },
  mounted () {
    this.displayAllEmailTemplate();
  },
  created () {
    this.verifyUser();
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
}
</script>

<style scoped>
  .hight-btn{
    padding: 30px 0 15px 0;
  }
  .text-align-left {
    text-align: left;
  }

  .page-title{
    font-size: 20px;
    margin-top: 30px;
  }
  .margin-top{
    margin-top: 30px;
  }
  .line {
    width: 1px;
    height: 700px;
    background-color: #e6e6e6;
    margin-left: 20px;
  }

  .stakeholder-category-table{
    margin-top: 15px;
  }

  .table-nav{
    position: fixed;
    bottom: 40px;
  }
  /*rewrite element-ui */
  >>>.dialog-form .el-input{
    width: 360px;
  }
  >>>.el-dialog__body{
    padding: 5px 70px;
  }
  >>>.el-dialog__footer {
    padding: 40px 70px 20px;
  }
  >>>.el-button{
    margin-top: auto;
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button:focus{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger{
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-table{
    color: black;
  }

  >>>.el-table thead{
    color: black;
  }

  >>>.el-form--label-top .el-form-item__label{
    padding: 0;
  }

  >>>.el-form-item{
    margin-bottom: 5px;
  }

  >>>.el-pager li.active{
    color: #5e89ed;
  }

  >>>.el-pager li:hover{
    color: #5e89ed;
  }

  >>>.el-checkbox__inner{
    border: 1px solid #aaaaaa;
  }

  >>>.el-form-item__label{
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/manager/EmailTemplateMaintenance.vue